import { render } from "./ForOrganizersPage.vue?vue&type=template&id=3d00fa50&scoped=true"
import script from "./ForOrganizersPage.vue?vue&type=script&lang=js"
export * from "./ForOrganizersPage.vue?vue&type=script&lang=js"

import "./ForOrganizersPage.vue?vue&type=style&index=0&id=3d00fa50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d00fa50"]])

export default __exports__